module.exports = __webpack_public_path__ + "img/image-mt-7.0c33a72e.png";